<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="4" xl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-calendar"></i>&nbsp;Ventas</b>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CInput
                  label="Desde"
                  type="date"
                  aria-label="shift_date"
                  @input="mtd_data"
                  size="sm"
                  id="init"
                  v-model="filter.init"
                />
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CInput
                  label="Hasta"
                  type="date"
                  aria-label="shift_date"
                  @input="mtd_data"
                  id="end"
                  size="sm"
                  v-model="filter.end"
                />
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CInput
                  label="Cantidad de Ventas"
                  type="text"
                  size="sm"
                  v-model="totalVentas"
                  disabled
                />
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CInput
                  label="Total de Ventas"
                  type="text"
                  size="sm"
                  v-model="sumaTotalVentas"
                  disabled
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="8" xl="9">
        <CTableWrapper
          v-if="showSalesTable"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          :items="data"
          small
          fixed
          caption="Lista de ventas de productos"
          icon="fas fa-coins"
          @mtdBack="mtdBack"
          :size="'md'"
          :actions="true"
          :withActions="'2%'"
          :myButtons="myButtons"
          @mtd_ticket="mtd_ticket"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "name", label: "Cliente", _style: "width:10%;" },
  { key: "phone", label: "Telefono", _style: "width:10%;" },
  { key: "quantity", label: "Cantidad", _style: "width:10%;" },
  { key: "type", label: "Tipo de compra", _style: "width:5%;" },
  { key: "subtotal", label: "Total", _style: "width:5%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../components/shared/datatable/Table.vue";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  created() {
    moment.locale("es");
    this.filter.end = moment().format("YYYY-MM-DD");
    this.filter.init = this.filter.end;
    this.mtd_data();
  },
  data() {
    return {
      filter: {
        init: null,
        end: null,
      },
      totalVentas: 0,
      sumaTotalVentas: 0,
      fields,
      data: [],
      showSalesTable: false,
      myButtons: [
        {
          class: "btn-sm",
          color: "dark",
          tooltip: "Ticket",
          action: "mtd_ticket",
          icon: "fas fa-file-pdf",
        },
      ],
    };
  },
  components: { CTableWrapper },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBack() {
      this.$router.push("/");
    },
    mtd_data() {
      this.post({
        url: this.$store.getters.get__url + "/sorteo/get/ticket",
        token: this.$store.getters.get__token,
        params: {
          init: this.filter.init,
          end: this.filter.end,
        },
      })
        .then((response) => {
          this.showSalesTable = true;
          this.data = response;
          this.totalVentas=response.length;
          this.sumaTotalVentas= response.reduce((sum, item) => sum + item.subtotal, 0)
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_ticket(payload) {
      if (payload.status == "PAGADO") {
        this.$swal({
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 3000,
          icon: "error",
          title: "YA CONFIRMASTE ESTOS TICKET!!",
          text: "",
        });
      } else {
        const ticketList = payload.detail
          .map((item) => `<li>Ticket N° <strong>${item.name}</strong></li>`)
          .join("");

        this.$swal({
          title: "¿Deseas confirmar estos tickets?",
          html: `<ul style="text-align: left;">${ticketList}</ul>`,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.isConfirmed) {
            this.post({
              url: this.$store.getters.get__url + "/sorteo/confirm/ticket",
              token: this.$store.getters.get__token,
              params: {
                id: payload.index,
              },
            })
              .then((response) => {
                this.$swal({
                  toast: true,
                  position: "center",
                  showConfirmButton: false,
                  timer: 3000,
                  icon: "success",
                  title: "CONFIRMADO!!",
                  text: "",
                });
                this.mtd_data();
              })
              .catch((errors) => {
                Swal.fire({
                  title: errors,
                  icon: "danger",
                });
              });
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>